import React from 'react';
import { withFormik } from 'formik';
import * as Yup from 'yup';
import isEmpty from 'lodash/isEmpty';
import PropTypes from 'prop-types';
// components
import Modal from 'shared/modals/Modal';
import { FormikInput, FormikTextarea } from 'shared/forms';
import LoadingModal from 'shared/loading/LoadingModal';

const websiteSchema = Yup.object().shape({
  url: Yup.string().required('URL is Required'),
  comment: Yup.string(),
});

const WebsiteModal = ({
  onClose,
  initialValues,
  organizationId,
  values,
  handleChange,
  handleBlur,
  handleSubmit,
  isSubmitting,
  resetForm,
  setSubmitting,
  touched,
  errors,
}) => {
  const isEditing = initialValues && initialValues.id;

  const handleReset = () => {
    onClose();
    resetForm();
  };

  const handleDelete = () => {
    setSubmitting(true);
    onClose({ organizationId, ...values, deleted: true });
    resetForm();
  };

  return (
    <Modal isOpen handleClose={handleReset} containerStyle="large">
      <div className="modal-header">
        <h5 className="modal-title" id="addAdditionalChargeModal">
          {isEditing ? 'Edit' : 'Create'} Website
        </h5>
        <button type="button" className="button large close" onClick={handleReset} />
      </div>
      <section className={`additional-charges-form modal-body ${isSubmitting ? 'hide-overflow' : ''}`}>
        <LoadingModal isOpen={isSubmitting} isNested={true} />
        <form onSubmit={handleSubmit}>
          <section className="formik-form rows">
            <div className="formik-row">
              <FormikInput
                wrapperClass="wrapper-two-column"
                type="text"
                label="URL*"
                name="url"
                value={values.url}
                onChange={handleChange}
                onBlur={handleBlur}
                touched={touched}
                errors={errors}
              />
            </div>
            <div className='formik-row'>
              <FormikTextarea
                wrapperClass='wrapper-fill-column wrapper-text-area-input'
                type='text'
                label='Comment'
                name='comment'
                value={values.comment}
                onChange={handleChange}
                onBlur={handleBlur}
                touched={touched}
                errors={errors}
              />
            </div>
          </section>
          <section className="toolbar toolbar--xxs">
            <div className="toolbar--column toolbar--right">
              <button
                type="submit"
                className="button large primary text-align--center toolbar--button--margin"
                disabled={isSubmitting || !isEmpty(errors)}
              >
                {values.id ? 'Update' : 'Add'}
              </button>
              {initialValues &&
                initialValues.id && (
                  <button
                    type="button"
                    className="button large error-color text-align--center toolbar--button--margin"
                    disabled={isSubmitting}
                    onClick={handleDelete}
                  >
                    Delete
                  </button>
                )}
              <button
                id="add-additional-charge-cancel"
                type="button"
                className="button large white text-align--center margin--none--xxs"
                onClick={handleReset}
              >
                Cancel
              </button>
            </div>
          </section>
        </form>
      </section>
    </Modal>
  );
};

WebsiteModal.propTypes = {
  onClose: PropTypes.func,
  initialValues: PropTypes.object,
  values: PropTypes.object,
  handleChange: PropTypes.func,
  handleBlur: PropTypes.func,
  handleSubmit: PropTypes.func,
  touched: PropTypes.object,
  errors: PropTypes.object,
  isSubmitting: PropTypes.bool,
  resetForm: PropTypes.func,
};

export default withFormik({
  enableReinitialize: true,
  mapPropsToValues: ({ initialValues }) => initialValues ? { ...initialValues } : { url: '', comment: '' },
  validationSchema: websiteSchema,
  handleSubmit: (values, { setSubmitting, props: { organizationId, onClose } }) => {
    setSubmitting(true);
    onClose({ organizationId, ...values });
  }
})(WebsiteModal);
